export default [
    {
        key: 'product.images',
        label: 'Images',
        variant: 'column-img'
    },
    {
        key: 'product.name',
        label: 'Name',
        sortable: true
    },
    {
        key: 'product.sku',
        label: 'SKU',
        sortable: true
    },
    {
        key: 'product.fnsku',
        label: 'FNSKU',
        sortable: true
    },
    {
        key: 'product.marketplaceRelation.amazonProductId',
        label: 'ASIN',
        sortable: true
    },
    {
        key: 'product.stock.available',
        label: 'Available',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'quantitySent',
        label: 'Number of Units',
        sortable: true,
        variant: 'column-md'
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/replenishmentItem.js